import ADIColors from "@NA/Utils/ADIColors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps {
    product: ProductModel;
    view: string;
    extendedStyles?: ADIProductPartNumbersStyles;
}
type Props = OwnProps;

export interface ADIProductPartNumbersStyles {
    partNumber?: TypographyProps;
}
export const adiProductPartNumbersStyles: ADIProductPartNumbersStyles = {
    partNumber: {
        size: 11,
        weight: 600,
        css: css`
            color: ${ADIColors.gray4};
        `,
    }
};
const ADIProductPartNumbers: FC<Props> = ({ product, view, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(adiProductPartNumbersStyles, extendedStyles));
    return (
        <>
        {view === "Grid" ? (
            <StyledWrapper>
                {product.manufacturerItem && (
                    <Typography {...styles.partNumber}>{product.manufacturerItem}</Typography>
                )}
                {product.erpNumber && (
                    <Typography {...styles.partNumber}>  <Typography>|</Typography>  {product.erpNumber}</Typography>
                )}
            </StyledWrapper>
        ) : (
            <StyledWrapper>
                {product.manufacturerItem && (
                    <Typography {...styles.partNumber}>MODEL #{product.manufacturerItem}</Typography>
                )}
                {product.erpNumber && (
                    <Typography {...styles.partNumber}>  |  ADI #{product.erpNumber}</Typography>
                )}
            </StyledWrapper>
        )}
        </>
    );
};
export default ADIProductPartNumbers;
